module.exports = __webpack_public_path__ + "img/chart_logo.062d0dc2.svg";